import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import React from "react";
import { Suspense } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ImageComponent from "../OrderCard/ImageComponent";
import TableHistory from "../../TableHistory";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& h2": {
    background: theme.palette.primary.main,
    color: "#fff",
    fontWeight: "500",
  },
}));

const DetailsDiv = styled(Box)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },
}));

const StyledDialogContent = styled(DialogContent)(({theme}) => ({
    
}))

const columnsNotification = [
//   { id: "orderNumber", name: "Order Number" },
  { id: "fromEmail", name: "From Email" },
  { id: "toEmail", name: "To Email" },
  { id: "message", name: "Message"},
  { id: "created_at", name: "Created At" },
  // { id: "updated_at", name: "Updated At" },
  // { id: "pendingProcess", name: "Status" },
  // { id: "actions", name: "Actions" },
];

const columnsNotificationSMS = [
//   { id: "orderNumber", name: "Order Number" },
{ id: "from_Store", name: "From Store" },
  { id: "destination_number", name: "Destination Number" },
  { id: "message", name: "Message"},
  { id: "created_at", name: "Created At" },
  { id: "isDaily", name: "Type" },
  { id: "status", name: "Status" },
  // { id: "actions", name: "Actions" },
];

const ViewHistory = (props) => {
  var parser, htmlData, body;
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
  });

  useEffect(() => {
    props.sendHistoryCallback(dialogDetails);
  }, [dialogDetails]);

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  // console.log("props", props);

  return (
    <StyledDialog
      open={dialogDetails.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Notification History
        <IconButton onClick={handleClose}>
          <Close style={{ color: "#fff" }} />
        </IconButton>
      </DialogTitle>

      <StyledDialogContent>
        <Box mt={2}>
        <TableHistory
          columns={
            props.notificationType === "sms"
              ? columnsNotificationSMS
              : columnsNotification
          }
          rows={props.historyDetails.history}
          historyDetails={props.historyDetails}
          footer={false}
        />
        </Box>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default ViewHistory;
